module.exports = __webpack_public_path__ + "media/images/icons/external-button-0d2610c5d585b3d7d5bf469a52f6c8fd.svg";